import React from 'react';
import cn from 'clsx';

import Link from '../../library/link/link';
import Typography from '../../library/typography/typography';
import TireAttributeIcon from './components/tire-attribute-icon/tire-attribute-icon.one-dt';

import {
  TIRE_ATTRIBUTE_ICON_DESCRIPTION,
  TIRE_ATTRIBUTES
} from '../../shared/constants/products';

import styles from './tire-attribute-icons.one-dt.scss';

interface TireAttributeIconsProps {
  className?: string;
  icons?: (typeof TIRE_ATTRIBUTES)[keyof typeof TIRE_ATTRIBUTES][];
  link?: string;
}

function TireAttributeIcons(props: TireAttributeIconsProps) {
  const { className = '', icons, link } = props;

  if (!(Array.isArray(icons) && icons.length > 0)) {
    return null;
  }

  return (
    <span
      className={cn(styles['container'], `tire-attribute-icons ${className}`)}
    >
      <TireAttributeIcon name={icons[0]} />
      <Typography className={styles['icon-description']} tag="span">
        {TIRE_ATTRIBUTE_ICON_DESCRIPTION[icons[0]].description ===
        'Three-Peak Mountain Snowflake'
          ? '3PMSF'
          : TIRE_ATTRIBUTE_ICON_DESCRIPTION[icons[0]].description}
      </Typography>
      {icons.length > 1 && link && (
        <>
          <ellipse className={styles['ellipse']} />
          <Link className={styles['icons-link']} to={link}>
            + {icons.length - 1}
          </Link>
        </>
      )}
    </span>
  );
}

export default TireAttributeIcons;
